module.exports = __webpack_public_path__ + "img/new-mobile-header-facebook.98a4d13a.jpg";